import moment from "moment";
// import "moment/dist/locale/kk-kz";
import "moment/locale/ru";

import i18n from "@/shared/config/i18n";

moment.locale(
  {
    kk: "kk",
    ru: "ru",
    en: "en",
  }[i18n.locale || "ru"]
);

export default {
  timestamp_to_utc(timestamp, format) {
    if (!format) {
      format = "DD MMM, HH:mm";
    }
    return moment.utc(timestamp * 1000).format(format);
  },

  difference_in_seconds(time_start, time_end) {
    if (!time_end) {
      time_end = moment().unix();
    }
    let diff_in_seconds = moment(time_end * 1000).diff(
      moment(time_start * 1000),
      "second"
    );
    if (diff_in_seconds < 0) {
      return 0;
    }
    return diff_in_seconds;
  },

  from_now(timestamp) {
    let datetime = moment(timestamp * 1000).format("DD MM YYYY, HH:mm");
    return moment(moment(datetime, "DD MM YYYY, HH:mm")).fromNow(true);
  },

  from_year(timestamp) {
    let now = moment().format("YYYY"),
      from = moment(timestamp * 1000).format("YYYY");
    if (now - from >= 1) {
      return from;
    }
    return 0;
  },

  subtract_two_date(date) {
    let date1 = moment(date[0] * 1000).format("YYYY"),
      date2 = moment(date[1] * 1000).format("YYYY");
    return date2 - date1;
  },

  timestamp_to_local_tz(timestamp, format) {
    if (!format) {
      format = "DD MMM, HH:mm";
    }
    return moment(timestamp).format(format);
  },

  get_timestamp() {
    return moment().unix();
  },

  date_to_timestamp(date) {
    return +moment.utc(moment(date).format("MM-DD-YYYY"), "MM-DD-YYYY");
  },

  datetimeDisplay(date, format) {
    if (date < 1000000000000) {
      return moment(date * 1000).format(format);
    }
    return moment(date).format(format);
  },

  seconds_to_time(seconds) {
    return moment.duration(seconds, "seconds");
  },
  sec2time(timeInSeconds) {
    var pad = function (num, size) {
        return ("000" + num).slice(size * -1);
      },
      time = parseFloat(timeInSeconds).toFixed(3),
      hours = Math.floor(time / 60 / 60),
      minutes = Math.floor(time / 60) % 60,
      seconds = Math.floor(time - minutes * 60);
    return pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
  },
  sec2timeStr(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const min = Math.floor(totalSeconds / 60) % 60;
    const seconds = (totalSeconds % 60).toFixed(0);
    return `${hours !== 0 ? String(hours) + " " + i18n.t("час") : ""} ${
      min !== 0 ? String(min) + " " + i18n.t("мин") : ""
    } ${String(seconds)} ${i18n.t("сек")}`;
  },

  sec3timeStr(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor(totalSeconds / 60) % 60;
    const seconds = Math.floor(totalSeconds % 60);

    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  },

  durationToHumanReadableFormatHoursMax(seconds) {
    if (!seconds || seconds < 60) return i18n.t("~меньше минуты");

    const hours = Math.floor(seconds / 3600);
    let remainingSeconds = seconds % 3600;
    const minutes = Math.floor(remainingSeconds / 60);

    const parts = [];
    if (hours > 0) {
      parts.push(`${hours + " " + i18n.t("ч.")}`);
    }
    if (minutes > 0) {
      parts.push(`${minutes + " " + i18n.t("мин.")}`);
    }

    return parts.join(" ");
  },
  durationToHumanReadableFormat(seconds) {
    if (!seconds || seconds < 60) return i18n.t("~меньше минуты");

    const days = Math.floor(seconds / 86400);
    let remainingSeconds = seconds % 86400;
    const hours = Math.floor(remainingSeconds / 3600);
    remainingSeconds %= 3600;
    const minutes = Math.floor(remainingSeconds / 60);

    const parts = [];
    if (days > 0) {
      parts.push(`${days + i18n.t("дн.")}`);
    }
    if (hours > 0) {
      parts.push(`${hours + i18n.t("час.")}`);
    }
    if (minutes > 0) {
      parts.push(`${minutes + i18n.t("мин.")}`);
    }

    return parts.join(" ");
  },
};
